export default "__VITE_ASSET__DUhqaX4U__"